import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import fetchWithAuth from 'store/_helpers/fetchWithAuth';
import fixImageUri from './fixImageUri';
import { getLuminance } from 'polished';

export default async function createTheme({ settings, logoUrl, pictureUrl, backgroundUrl }) {
  if (!logoUrl && !pictureUrl && !backgroundUrl && _isEmpty(settings)) return undefined;
  const primaryTheme = _get(settings, 'palette.primary.main');
  const secondaryTheme = _get(settings, 'palette.secondary.main');
  let updatedSettings = { ...settings };

  updatedSettings = primaryTheme
    ? {
        ...settings,
        palette: {
          ...settings.palette,
          primary: {
            ...settings.palette.primary,
            contrastText: getContrastColor(primaryTheme),
          },
        },
      }
    : updatedSettings;

  updatedSettings = secondaryTheme
    ? {
        ...settings,
        palette: {
          ...settings.palette,
          secondary: {
            ...settings.palette.secondary,
            contrastText: getContrastColor(secondaryTheme),
          },
        },
      }
    : updatedSettings;

  // 1) create initial theme without images
  const initialThemeResponse = await fetchWithAuth(`/api/themes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      settings: {
        ...updatedSettings,
        _notEmpty: true, // stop yelling at me, jonathon
      },
      logoUrl: null,
      pictureUrl: null,
      backgroundUrl: null,
    }),
  });
  const initialTheme = await initialThemeResponse.json();
  const themeId = initialTheme.id;

  // 2) sign and upload image uploads or return the S3 URL if it doesn't need to be converted
  const [logoUrlFixed, backgroundUrlFixed, pictureUrlFixed] = await Promise.all([
    fixImageUri(themeId, 'sign-logo-upload', logoUrl),
    fixImageUri(themeId, 'sign-background-upload', backgroundUrl),
    fixImageUri(themeId, 'sign-picture-upload', pictureUrl),
  ]);

  // 3) update the theme to include S3 image links
  const updateResponse = await fetchWithAuth(`/api/themes/${themeId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      settings: {
        ...updatedSettings,
        _notEmpty: true, // stop yelling at me, jonathon
      },
      logoUrl: logoUrlFixed || null,
      backgroundUrl: backgroundUrlFixed || null,
      pictureUrl: pictureUrlFixed || null,
    }),
  });

  return updateResponse.json();
}

// These values must stay consistent due to how they are used in email templates. Email templates will do an exact match check on these values.
// Do not use '#fff' or a different value without changing the value on the email templates.
const WHITE = '#ffffff';
const BLACK = '#212121';

function getContrastColor(themeColor) {
  return getLuminance(themeColor) > 0.3 ? BLACK : WHITE;
}
